export default {
  // Navigation
  nav_home: 'Home',
  nav_dashboard: 'Dashboard',
  nav_orders: 'Orders',
  nav_wallet: 'Wallet',
  nav_analytics: 'Analytics',
  nav_referral: 'Referral',
  nav_account: 'Account',
  nav_notifications: 'Notifications',
  nav_logout: 'Logout',
  nav_login: 'Login',
  nav_signup: 'Sign Up',
  nav_deposit_requests: 'Deposit Requests',
  nav_withdraw_requests: 'Withdraw Requests',
  nav_support_ticket: 'Support Ticket',
  nav_system_logs: 'System Logs',
  nav_announcements: 'Announcements',
  nav_activity_logs: 'Activity Logs',
  nav_settings: 'Settings',
  nav_section_main: 'Main',
  nav_user_active: 'Active now',
  nav_more: 'More',
  nav_logout_confirm: 'Are you sure you want to logout?',
  nav_language: 'Language',

  // Dashboard
  dashboard_welcome: 'Welcome back',
  dashboard_total_earnings: 'Total Earnings',
  dashboard_pending_orders: 'Pending Orders',
  dashboard_completed_orders: 'Completed Orders',
  dashboard_commission_rate: 'Commission Rate',
  dashboard_quick_actions: 'Quick Actions',
  dashboard_recent_orders: 'Recent Orders',
  dashboard_recent_activity: 'Recent Activity',
  dashboard_wallet_balance: 'Wallet Balance',
  dashboard_deposit: 'Deposit',
  dashboard_withdraw: 'Withdraw',
  dashboard_view_all: 'View All',
  greeting_morning: 'Good Morning',
  greeting_afternoon: 'Good Afternoon',
  greeting_evening: 'Good Evening',
  dashboard_greeting_desc: 'Track your earnings, complete orders, and manage your account all in one place. Your success journey continues here!',

  // Dashboard Stats
  stats_available_balance: 'Available Balance',
  stats_total_withdrawn: 'Total Withdrawn',
  stats_total_deposit: 'Total Deposit',
  stats_pending_orders: 'Pending Orders',
  stats_orders_suffix: ' orders',
  stats_task_earnings: 'Task Earnings',
  stats_lifetime_earning: 'Lifetime Earning',

  // Orders
  orders_title: 'My Orders',
  orders_all: 'All Orders',
  orders_pending: 'Pending',
  orders_completed: 'Completed',
  orders_cancelled: 'Cancelled',
  orders_order_id: 'Order ID',
  orders_platform: 'Platform',
  orders_amount: 'Amount',
  orders_commission: 'Commission',
  orders_status: 'Status',
  orders_date: 'Date',
  orders_actions: 'Actions',
  orders_no_orders: 'No orders found',

  // Wallet
  wallet_title: 'My Wallet',
  wallet_available_balance: 'Available Balance',
  wallet_pending_balance: 'Pending Balance',
  wallet_total_withdrawn: 'Total Withdrawn',
  wallet_deposit_now: 'Deposit Now',
  wallet_withdraw_now: 'Withdraw Now',
  wallet_transaction_history: 'Transaction History',
  wallet_deposit_history: 'Deposit History',
  wallet_withdrawal_history: 'Withdrawal History',

  // Analytics
  analytics_title: 'Analytics',
  analytics_earnings_overview: 'Earnings Overview',
  analytics_platform_breakdown: 'Platform Breakdown',
  analytics_performance_metrics: 'Performance Metrics',
  analytics_top_products: 'Top Products',
  analytics_this_month: 'This Month',
  analytics_last_month: 'Last Month',
  analytics_total_revenue: 'Total Revenue',
  analytics_avg_order_value: 'Avg Order Value',

  // Referral
  referral_title: 'Referral Program',
  referral_your_code: 'Your Referral Code',
  referral_copy_code: 'Copy Code',
  referral_share_link: 'Share Link',
  referral_total_referrals: 'Total Referrals',
  referral_active_referrals: 'Active Referrals',
  referral_referral_earnings: 'Referral Earnings',
  referral_invite_friends: 'Invite Friends',

  // Account
  account_title: 'Account Settings',
  account_profile: 'Profile',
  account_security: 'Security',
  account_notifications: 'Notifications',
  account_kyc: 'KYC Verification',
  account_phone: 'Phone Number',
  account_two_factor: 'Two-Factor Authentication',
  account_save_changes: 'Save Changes',
  account_cancel: 'Cancel',

  // Auth & Common
  auth_email: 'Email',
  auth_password: 'Password',
  auth_confirm_password: 'Confirm Password',
  auth_forgot_password: 'Forgot Password?',
  auth_remember_me: 'Remember Me',
  auth_login_button: 'Login',
  auth_signup_button: 'Sign Up',
  auth_already_have_account: 'Already have an account?',
  auth_dont_have_account: "Don't have an account?",
  auth_reset_password: 'Reset Password',
  auth_verify_email: 'Verify Email',
  auth_live_platform: 'Live Platform',
  auth_security_verification: 'Security Verification',
  auth_captcha_refresh: 'Refresh',
  auth_captcha_placeholder: 'Result',
  auth_captcha_error: 'Incorrect sum, please try again',
  auth_branding_title: 'Turn Promotions Into',
  auth_branding_highlight_prefix: '',
  auth_branding_highlight: 'Real Income',
  auth_branding_desc: 'Join thousands of promoters earning daily commissions from top e-commerce brands worldwide.',
  auth_sign_in_to_account: 'Sign in to your {{system_name}} account',
  auth_email_placeholder: 'you@example.com',
  auth_password_placeholder: 'Enter your password',
  auth_signing_in: 'Signing in...',
  auth_free_to_join: 'Free to Join',
  auth_signup_branding_title: 'Start Earning',
  auth_signup_branding_highlight: 'From Day One',
  auth_signup_branding_desc: 'No experience needed. Sign up in 2 minutes and start completing tasks for top e-commerce brands.',
  auth_how_it_works: 'How it works',
  auth_signup_desc: 'Join {{system_name}} and start earning commissions today — it\'s free!',
  auth_step_1: 'Create your free account',
  auth_step_2: 'Browse & accept tasks',
  auth_step_3: 'Complete & earn commissions',
  auth_signup_step_1_title: 'Create Account',
  auth_signup_step_1_desc: 'Start your journey',
  auth_signup_step_2_title: 'Complete Tasks',
  auth_signup_step_2_desc: 'Earn daily commissions',
  auth_signup_step_3_title: 'Withdraw Funds',
  auth_signup_step_3_desc: 'Fast and secure payouts',
  auth_benefit_1_title: 'Secure & Trusted',
  auth_benefit_1_desc: 'Bank-level security for your earnings',
  auth_benefit_2_title: 'Instant Payouts',
  auth_benefit_2_desc: 'Withdraw earnings within 24 hours',
  auth_benefit_3_title: 'Global Community',
  auth_benefit_3_desc: 'Join 12,000+ active promoters',
  auth_benefit_4_title: '24/7 Support',
  auth_benefit_4_desc: 'Get help whenever you need it',
  auth_strength_weak: 'Weak',
  auth_strength_fair: 'Fair',
  auth_strength_good: 'Good',
  auth_strength_strong: 'Strong',
  auth_password_strength: 'Password strength: {{strength}}',
  auth_social_proof: 'Join {{count}}+ earners',
  auth_passwords_match: 'Passwords match',
  auth_creating_account: 'Creating account...',
  auth_phone_number: 'Phone Number',
  auth_phone_optional: '(Optional)',
  auth_phone_placeholder: 'Your phone number',
  auth_full_name: 'Full Name',
  auth_full_name_placeholder: 'John Doe',
  auth_password_min_chars: 'At least 8 characters',
  auth_confirm_password_placeholder: 'Repeat your password',
  auth_agree_to: 'I agree to the',
  auth_terms_of_service: 'Terms of Service',
  auth_privacy_policy: 'Privacy Policy',
  auth_and: 'and',
  auth_create_free_account: 'Create Free Account',

  common_loading: 'Loading...',
  common_save: 'Save',
  common_cancel: 'Cancel',
  common_delete: 'Delete',
  common_edit: 'Edit',
  common_view: 'View',
  common_search: 'Search',
  common_filter: 'Filter',
  common_export: 'Export',
  common_import: 'Import',
  common_submit: 'Submit',
  common_close: 'Close',
  common_confirm: 'Confirm',
  common_success: 'Success',
  common_error: 'Error',
  common_warning: 'Warning',
  common_announcement: 'Announcement',

  val_full_name_required: 'Full name is required',
  val_email_required: 'Email is required',
  val_password_required: 'Password is required',
  val_password_min: 'Password must be at least 8 characters',
  val_passwords_dont_match: 'Passwords do not match',
  val_agree_terms: 'You must agree to the terms',
  val_conn_error: 'Connection error. Please try again.',

  // Homepage
  home_hero_title: 'Earn Commission from Top E-Commerce Platforms',
  home_hero_subtitle: 'Join thousands of users earning daily commissions from Amazon, Alibaba, and AliExpress',
  home_get_started: 'Get Started Now',
  home_learn_more: 'Learn More',
  home_how_it_works: 'How It Works',
  home_features: 'Features',
  home_why_choose_us: 'Why Choose Us',
  home_features_title: 'Powerful Features',
  home_features_subtitle: 'Everything you need to start earning online. Built with your success in mind.',
  home_commission_tiers: 'Commission Tiers',
  home_testimonials: 'What Our Users Say',
  home_faq: 'FAQ',
  home_cta_title: 'Ready to Start Earning?',
  home_cta_subtitle: 'Join our community today and start earning commissions',
  home_trusted_partner: 'Trusted Partner Platforms',
  home_secure_platform: 'Secure Platform',
  home_instant_payouts: 'Instant Payouts',
  home_active_users: 'Active Users',
  home_paid_out: 'Paid Out',
  home_total_paid_out: 'Total Paid Out',
  home_user_rating: 'User Rating',
  home_countries: 'Countries',
  home_commission_badge: 'Earning Potential',
  home_commission_title: 'Commission Rates',
  home_commission_desc: 'Higher balance unlocks better commission rates. Each session assigns exactly 25 orders — complete up to 4 sessions daily for maximum earnings.',
  home_tier_popular: 'Most Popular',
  home_tier_commission_per_order: 'Commission Per Order',
  home_tier_earn_examples: 'Earnings Examples:',
  home_tier_order: 'order',
  home_tier_batch_earn: '25 orders/batch earn:',
  home_tier_daily_potential: 'Daily Potential (4 batches × 25 orders)',
  home_tier_max_daily: 'Up to 100 orders per day',
  home_tier_benefit_1: '25 orders per batch',
  home_tier_benefit_2: 'Max 4 batches per day',
  home_tier_benefit_3: 'Instant commission credit',
  home_tier_above: 'Above',
  home_tier_no_tiers: 'No commission tiers found.',

  // Comparison Section
  home_compare_badge: 'The Difference',
  home_compare_title: 'Why We Are Better',
  home_compare_subtitle: 'Compare our platform with traditional part-time jobs and see why thousands choose us.',
  home_compare_feature: 'Feature',
  home_compare_traditional: 'Traditional Jobs',
  home_compare_our_platform: 'Our Platform',
  home_compare_f1: 'Flexibility',
  home_compare_f1_trad: 'Fixed schedules',
  home_compare_f1_our: 'Work anytime, anywhere',
  home_compare_f2: 'Payouts',
  home_compare_f2_trad: 'Monthly or Bi-weekly',
  home_compare_f2_our: 'Instant / Same day',
  home_compare_f3: 'Requirements',
  home_compare_f3_trad: 'Experience/CV/Interview',
  home_compare_f3_our: 'None - Just a smartphone',
  home_compare_f4: 'Growth',
  home_compare_f4_trad: 'Fixed annual raises',
  home_compare_f4_our: 'Uncapped tier-based growth',

  // Testimonials
  home_testi_badge: 'Success Stories',
  home_testi_title: 'Trusted by Thousands',
  home_testi_subtitle: 'Hear from our global community of promoters who have transformed their income.',
  home_testi_no_stories: 'No success stories available yet.',
  home_testi_total_earned: 'Total Earned',
  home_testi_time_period: 'Time Period',
  home_testi_verified: 'Verified User',
  home_testi_avg_rating: 'Average Rating',
  home_testi_satisfaction_rate: 'Satisfaction Rate',
  home_testi_support_available: 'Support Available',

  // FAQ
  home_faq_badge: 'Support',
  home_faq_title: 'Common Questions',
  home_faq_subtitle: 'Everything you need to know about getting started and earning.',
  home_faq_no_data: 'No questions found.',

  // Trust Bar
  home_trust_badge: 'Global Trust',
  home_trust_title: 'Trusted by Leading Brands',
  home_trust_desc: 'We partner with the world\'s largest e-commerce platforms to provide verified promotion services.',

  // Feature Section
  feature_1_title: 'Instant Payouts',
  feature_1_desc: 'Get your earnings credited immediately after order completion. Withdraw anytime with zero delays.',
  feature_1_detail_1: 'Real-time commission credit',
  feature_1_detail_2: 'Multiple withdrawal options',
  feature_1_detail_3: 'No minimum threshold',
  feature_2_title: 'Secure Platform',
  feature_2_desc: 'Bank-level encryption protects your data and earnings. Trusted by thousands of users worldwide.',
  feature_2_detail_1: 'SSL encryption enabled',
  feature_2_detail_2: 'Two-factor authentication',
  feature_2_detail_3: 'Regular security audits',
  feature_2_detail_4: 'Data privacy guaranteed',
  feature_3_title: 'Flexible Hours',
  feature_3_desc: 'Work whenever you want, wherever you are. Complete orders at your own pace with no fixed schedule.',
  feature_3_detail_1: 'No fixed working hours',
  feature_3_detail_2: 'Work from anywhere',
  feature_3_detail_3: 'Choose your own pace',
  feature_3_detail_4: 'Weekend availability',
  feature_4_title: 'Progressive Earnings',
  feature_4_desc: 'Unlock higher commission rates as you complete more orders. Grow your income with every tier upgrade.',
  feature_4_detail_1: 'Tier-based commission rates',
  feature_4_detail_2: 'Automatic tier upgrades',
  feature_4_detail_3: 'Performance rewards',
  feature_5_title: 'Global Platform',
  feature_5_desc: 'Work with international brands from anywhere in the world. Multi-currency support included.',
  feature_5_detail_1: 'Available worldwide',
  feature_5_detail_2: 'Multi-currency support',
  feature_5_detail_3: 'Local payment methods',

  // Home Page Additional Sections
  home_how_it_works_badge: 'Simple Process',
  home_how_it_works_title: 'How It Works',
  home_how_it_works_subtitle: 'Start earning in 4 simple steps. No experience needed, just follow the process and watch your earnings grow.',
  home_cta_ready_title: 'Ready to Start Your Journey?',
  home_cta_ready_desc: 'Join thousands of users already earning daily. Your first commission is just minutes away!',
  home_cta_avg_time: 'Average time to first earning:',
  home_cta_15_mins: '15 minutes',
  home_cta_new_users: 'New users today:',

  // CTA Section (Premium)
  home_cta_limit_spots: 'Limited Spots Available This Month',
  home_cta_main_title: 'Start Earning Money',
  home_cta_today: 'Today!',
  home_cta_main_desc: 'Join thousands of users already earning daily commissions. No experience needed, flexible hours, instant payouts. Your financial freedom starts here.',
  home_cta_spots_remaining: 'Spots Remaining',
  home_cta_new_users_today: 'New Users Today',
  home_cta_create_account: 'Create Free Account',
  home_cta_sign_in: 'Sign In',
  home_cta_secure: '100% Secure',
  home_cta_payouts: '24-48h Payouts',
  home_cta_rating: '4.9/5 Rating',
  home_cta_active_users: 'Active Users',
  home_cta_total_paid: 'Total Paid',
  home_cta_orders_done: 'Orders Done',
  home_cta_satisfaction: 'Satisfaction',
  home_cta_guarantee_title: 'Money-Back Guarantee',
  home_cta_guarantee_desc: 'Not satisfied? Get your deposit back within 7 days',

  // Footer Branding & Extras
  footer_brand_desc: 'The world\'s leading e-commerce promotion platform. Join our global network of promoters and start earning commissions from top brands today.',
  footer_ssl_secure: 'SSL Secured',
  footer_aes_256: 'AES-256 Encryption',
  footer_cookie_policy: 'Cookie Policy',
  footer_disclaimer: 'Disclaimer',
  footer_all_rights: 'All rights reserved.',

  // Announcements
  announcement_withdrawal_delay_title: 'Withdrawal Processing Delay',
  announcement_withdrawal_delay_summary: 'Withdrawals may take up to 72 hours due to increased volume. Please plan accordingly.',
  announcement_date_june_14: 'June 14, 2025',

  // Wallet Page & Detailed Requests
  wallet_page_desc: 'Manage your earnings and transactions',
  wallet_err_fetch: 'Failed to fetch wallet data',
  wallet_err_fetch_summary: 'An error occurred while fetching wallet summary',
  wallet_unlock_withdrawal: 'Complete all 25 orders to unlock withdrawal',
  wallet_withdrawals_badge: 'Withdrawals',
  wallet_pending_badge: 'Pending',
  wallet_total_earnings_badge: 'Total Earnings',
  wallet_err_fetch_deposits: 'Failed to fetch deposits',
  wallet_cancel_deposit_confirm: 'Are you sure?',
  wallet_cancel_deposit_text: 'You want to cancel this deposit request?',
  wallet_cancel_deposit_yes: 'Yes, cancel it!',
  wallet_cancel_deposit_success: 'Deposit request deleted successfully.',
  wallet_cancel_deposit_err: 'Failed to delete deposit',
  wallet_cancel_deposit_err_summary: 'An error occurred while deleting deposit',
  wallet_no_deposits_title: 'No deposits yet',
  wallet_no_deposits_desc: "You haven't made any deposits. Click the Deposit button above to add funds to your wallet!",
  wallet_cancel_tooltip: 'Cancel Deposit',
  wallet_status_completed: 'Completed',
  wallet_status_rejected: 'Rejected',
  wallet_status_pending: 'Pending',
  wallet_table_date: 'Date',
  wallet_table_trx: 'Transaction ID',
  wallet_table_desc: 'Description',
  wallet_table_amount: 'Amount',
  wallet_table_status: 'Status',
  wallet_table_actions: 'Actions',
  wallet_table_id: 'ID',
  wallet_load_more: 'Load More',
  wallet_loading: 'Loading...',
  wallet_err_fetch_transactions: 'Failed to fetch transactions',
  wallet_filter_all: 'All',
  wallet_filter_deposits: 'Deposits',
  wallet_filter_withdrawals: 'Withdrawals',
  wallet_filter_commissions: 'Commissions',
  wallet_no_transactions_title: 'No transactions yet',
  wallet_no_transactions_desc: "You don't have any {{filter}} transactions. Start earning commissions or make a deposit!",
  wallet_deposit_desc: "Add money to your wallet using available payment methods.",
  wallet_no_deposits: "No deposits found.",
  wallet_withdraw_history: "Withdraw History",
  wallet_withdraw_desc: "Withdraw money from your wallet.",
  wallet_no_withdrawals: "No withdrawals found.",
  wallet_no_withdrawals_desc: "You have not made any withdrawals yet.",

  // Deposit & Withdraw Requests Pages
  deposit_requests_title: 'Deposit Requests',
  deposit_requests_desc: 'View and manage your deposit requests',
  withdraw_requests_title: 'Withdraw Requests',
  withdraw_requests_desc: 'View and manage your withdrawal requests',

  // Orders Page (Detailed)
  orders_step_1: 'Reviewing Product Details',
  orders_step_2: 'Verifying Order Info',
  orders_step_3: 'Connecting to Platform',
  orders_step_4: 'Submitting Promotion',
  orders_step_5: 'Finalizing & Confirming',
  orders_no_active_tasks: 'No active tasks available.',
  orders_err_fetch_task: 'Failed to fetch active task',
  orders_err_oops: 'Oops...',
  orders_err_process: 'Failed to process order',
  orders_err_title: 'Error',
  orders_err_occured: 'An error occurred while processing the order.',
  orders_submitting_task: 'Submitting Task...',
  orders_submitting_desc: 'Please wait while we process your completion and transfer funds.',
  orders_completed_title: 'Task Completed!',
  orders_completed_desc: 'Commissions have been added to your wallet.',
  orders_submit_failed: 'Submission Failed',
  orders_submit_err: 'Failed to submit task',
  orders_submit_err_occured: 'An error occurred while submitting the task.',
  orders_page_desc: 'Complete orders to earn commissions directly to your wallet.',
  orders_loading_data: 'Loading task data...',
  orders_no_pending: 'No Pending Tasks',
  orders_progress: 'Task Progress',
  orders_suffix: 'orders',
  orders_total_earned: 'Total Earned Commission:',
  orders_toast_completed: 'Order Completed!',
  orders_toast_desc: '{{amount}} expected commission has been calculated.',
  orders_congrats: "Congratulations! You've completed all {{required}} orders and earned {{total}} in total commissions for this task.",
  orders_btn_claim: 'Claim Your Commission',
  orders_btn_submitting: 'Submitting...',
  orders_prefix: 'Order #',
  orders_release_desc: 'Please release this order to secure your commission.',
  orders_expected_earn: 'Total Expected Earn',
  orders_processing: 'Processing...',
  orders_btn_release: 'Release Order',
  orders_how_it_works: 'How It Works',
  orders_grab_title: 'Grab Order',
  orders_grab_desc: 'Click "Release Order" to start processing. Orders are assigned sequentially and cannot be skipped.',
  orders_promote_title: 'Promote Product',
  orders_promote_desc: 'Our system automatically promotes the product across multiple platforms and optimizes for search visibility.',
  orders_earn_title: 'Earn Commission',
  orders_earn_desc: 'Commission is calculated instantly upon each order completion.',
  orders_claim_title: 'Claim & Withdraw',
  orders_claim_desc: 'Submit your fully completed task to permanently move your earnings into your wallet.',
  orders_rules_title: 'Order Rules',
  orders_rule_1: 'You must complete all required orders in your assigned task',
  orders_rule_2: 'Once your task is completed, click Claim Your Commission to transfer funds',
  orders_rule_3: 'Orders must be completed in sequence — no skipping allowed',
  orders_rule_4: 'Do not close the page during order processing',
  orders_rule_5: 'Fraudulent activity will result in account suspension',
  orders_processing_title: 'Processing Your Order',
  orders_processing_stay: 'Do not close this window',
  orders_platform_amazon: 'Amazon',
  orders_platform_ebay: 'eBay',
  orders_platform_aliexpress: 'AliExpress',
  orders_platform_default: 'Platform',

  // Analytics Page (Detailed)
  analytics_7_days: '7 Days',
  analytics_30_days: '30 Days',
  analytics_90_days: '90 Days',
  analytics_all_time: 'All Time',
  analytics_perf_title: 'Performance Analytics',
  analytics_perf_desc: 'Track your earnings and order performance across all platforms.',
  analytics_total_earnings_stat: 'Total Earnings',
  analytics_orders_completed_stat: 'Orders Completed',
  analytics_avg_commission_stat: 'Avg. Commission',
  analytics_conversion_rate_stat: 'Conversion Rate',
  analytics_timeline_title: 'Performance Over Time',
  analytics_timeline_desc: 'Visualization of your activity',
  analytics_earnings_tab: 'Earnings',
  analytics_orders_tab: 'Orders',
  analytics_distribution: 'Platform Distribution',
  analytics_strongest_on: 'Your performance is strongest on {{platform}}.',
  analytics_top_performing: 'Top Performing Products',
  analytics_top_suffix: 'Top {{count}}',
  analytics_product_info: 'Product Info',
  analytics_platform: 'Platform',
  analytics_rate: 'Rate',
  analytics_earned: 'Earned',
  analytics_no_data: 'No product data available for this period.',

  // Notifications Page
  notifications_title: 'Announcements & News',
  notifications_desc: 'Stay up to date with the latest platform updates and news',
  notifications_unread: 'unread announcement',
  notifications_unread_plural: 'unread announcements',
  notifications_caught_up: 'All caught up!',
  notifications_no_announcements: 'No announcements in this category',
  notifications_pinned: 'Pinned',
  notifications_new: 'NEW',
  notifications_published: 'Published:',
  notifications_read: 'Read',
  notifications_tab_all: 'All',
  notifications_tab_update: 'Update',
  notifications_tab_maintenance: 'Maintenance',
  notifications_tab_promotion: 'Promotion',
  notifications_tab_news: 'News',
  notifications_tab_alert: 'Alert',

  // Activity Logs
  activity_title: 'Personal Activity Logs',
  activity_desc: 'Account actions for security auditing',
  activity_action: 'Action',
  activity_details: 'Details',
  activity_ip: 'IP Address',
  activity_date: 'Date',
  activity_no_logs: 'No activity logs found',
  activity_prev: 'Previous',
  activity_next: 'Next',
  activity_page_of: 'Page {{current}} of {{total}}',

  // Account & Profile
  account_profile_title: 'Account Profile',
  account_profile_desc: 'Manage your personal information and avatar',
  account_info_title: 'Profile Information',
  account_edit_btn: 'Edit',
  account_avatar_alt: 'Profile avatar',
  account_avatar_hint: 'JPG, PNG or GIF • Max 2MB',
  account_avatar_invalid: 'Please upload a valid image file (JPG, PNG, or GIF)',
  account_avatar_size: 'File size must be less than 2MB',
  account_avatar_err: 'Failed to upload image',
  account_avatar_conn_err: 'Connection error during upload',
  account_full_name: 'Full Name',
  account_email_addr: 'Email Address',
  account_phone_num: 'Phone Number',
  account_not_set: 'Not set',
  account_save_btn: 'Save Changes',
  account_updating: 'Updating...',
  account_update_success: 'Profile updated successfully!',
  account_update_err: 'Failed to update profile',
  account_auth_err: 'Not authenticated',
  account_fetch_err: 'Failed to fetch profile',
  account_conn_err: 'Connection error',

  // KYC Section
  kyc_title: 'KYC Verification',
  kyc_status_unverified: 'Unverified',
  kyc_status_pending: 'Pending Review',
  kyc_status_approved: 'Approved',
  kyc_status_rejected: 'Rejected',
  kyc_loading: 'Loading identity status...',
  kyc_complete_title: 'Verification Complete',
  kyc_complete_desc: 'Your identity has been verified. You now have full access to all platform features.',
  kyc_submitted_title: 'Documents Submitted',
  kyc_submitted_desc: 'Your documents are under review. This usually takes 1–3 business days.',
  kyc_verified_details: 'Verified Details',
  kyc_unlock_desc: 'Complete identity verification to unlock full withdrawal access and higher limits.',
  kyc_dob: 'Date of Birth',
  kyc_country: 'Country',
  kyc_id_number: 'ID Number',
  kyc_address: 'Address',
  kyc_address_placeholder: 'Street address, city, postcode',
  kyc_select_id: 'Select Document Type',
  kyc_national_id: 'National ID',
  kyc_passport: 'Passport',
  kyc_driving_license: "Driver's License",
  kyc_id_doc: 'Identity Document',
  kyc_selfie: 'Selfie Verification',
  kyc_guidelines_title: 'Upload Guidelines',
  kyc_guidelines_1: 'Documents must be valid and not expired',
  kyc_guidelines_2: 'All four corners of the document must be visible',
  kyc_guidelines_3: 'Images must be clear, well-lit, and in focus',
  kyc_guidelines_4: 'Accepted formats: JPG, PNG, PDF (max 5MB)',
  kyc_submit_btn: 'Submit for Verification',
  kyc_submitting: 'Submitting...',
  kyc_err_submit: 'Failed to submit KYC. Please try again.',
  kyc_err_conn: 'Connection error. Please try again.',
  kyc_upload_replace: 'Tap to replace',
  kyc_upload_click: 'Click to upload',

  // Security Section
  security_row_title: 'Security Settings',
  security_login_pw: 'Login Password',
  security_login_pw_desc: 'Change your account login password',
  security_change_btn: 'Change',
  security_pw_current: 'Current Password',
  security_pw_new: 'New Password',
  security_pw_confirm: 'Confirm New Password',
  security_pw_placeholder_current: 'Enter current password',
  security_pw_placeholder_new: 'Enter new password',
  security_pw_placeholder_confirm: 'Re-enter new password',
  security_pw_success: 'Password changed successfully! Redirecting to login...',
  security_pw_err: 'Failed to change password',
  security_fill_all: 'Please fill in all fields.',
  security_match_err: 'Passwords do not match.',

  // Support Tickets
  support_page_title: 'Support Tickets',
  support_page_desc: "Need help? We're here for you.",
  support_btn_create: 'Create New Ticket',
  support_table_info: 'Ticket Info',
  support_table_cat: 'Category',
  support_table_pri: 'Priority',
  support_table_status: 'Status',
  support_table_activity: 'Last Activity',
  support_table_action: 'Action',
  support_id_prefix: 'ID:',
  support_btn_view: 'View',
  support_status_open: 'Open',
  support_status_closed: 'Closed',
  support_status_pending: 'Pending',
  support_priority_default: 'Normal',
  support_no_tickets: 'No tickets found. Have a question? Create your first ticket!',
  support_err_load: 'Failed to load tickets',
  support_err_fetch: 'An error occurred while fetching tickets',
  support_details_err_load: 'Failed to load ticket details',
  support_details_err_fetch: 'An error occurred while fetching ticket details',
  support_reply_success: 'Reply sent successfully',
  support_reply_err: 'Failed to send reply',
  support_reply_err_occured: 'An error occurred while sending your reply',
  support_file_size_err: 'File size must be less than 5MB',
  support_ticket_id_prefix: 'Ticket ID:',
  support_team: 'Support Team',
  support_you: 'You',
  support_view_attachment: 'View Attachment',
  support_placeholder_reply: 'Type your reply here...',
  support_attach_file: 'Attach file',
  support_btn_send: 'Send Reply',
  support_modal_title: 'New Support Ticket',
  support_modal_desc: 'Describe your issue for better assistance',
  support_subject: 'Subject',
  support_subject_placeholder: 'Brief summary of the issue',
  support_message: 'Message',
  support_message_placeholder: 'Explain your problem in detail...',
  support_attachment: 'Attachment (Optional)',
  support_attachment_hint: 'Click to upload screenshot or file (Max 5MB)',
  support_btn_creating: 'Creating...',
  support_btn_submit: 'Submit Ticket',
  support_category_billing: 'Billing',
  support_category_technical: 'Technical',
  support_category_account: 'Account',
  support_category_other: 'Other',
  support_priority_low: 'Low',
  support_priority_medium: 'Medium',
  support_priority_high: 'High',

  // Settings
  settings_page_title: 'Settings',
  settings_page_desc: 'Manage your security, privacy, and preferences',
  settings_kyc_label: 'KYC Verification',
  settings_kyc_desc: 'Identity verification',
  settings_security_label: 'Security',
  settings_security_desc: 'Password management',

  // How It Works Steps
  step_1_title: 'Create an Account',
  step_1_desc: 'Create your account in less than 2 minutes.',
  step_1_detail_1: 'Provide basic information',
  step_1_detail_2: 'Verify your email',
  step_1_detail_3: 'Secure your account',
  step_1_detail_4: 'Instant dashboard access',

  step_2_title: 'Find Tasks',
  step_2_desc: 'Choose from available promotion tasks.',
  step_2_detail_1: 'Filter by platform',
  step_2_detail_2: 'View commission rates',
  step_2_detail_3: 'Accept multiple tasks',
  step_2_detail_4: 'Real-time task updates',

  step_3_title: 'Complete Tasks',
  step_3_desc: 'Complete promotions according to instructions.',
  step_3_detail_1: 'Easy-to-follow steps',
  step_3_detail_2: 'Quick promotion submission',
  step_3_detail_3: 'Automatic verification',
  step_3_detail_4: 'Mobile-friendly interface',

  step_4_title: 'Earn & Withdraw',
  step_4_desc: 'Get paid for every completed task.',
  step_4_detail_1: 'Real-time earnings tracking',
  step_4_detail_2: 'Low minimum withdrawal limit',
  step_4_detail_3: 'Multiple payment methods',
  step_4_detail_4: '24/7 withdrawal support',
};